import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toggle/style.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "typeface-montserrat";
import LocalizationService from "./Services/localization.service";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";
import {
    COGNITO_SSO_TOKEN,
    handle401Error,
    isUserAuthenticated,
    isUserChanged,
    OWNER_NUMBER, SYSTEM_INTEGRATION_MODE, X_CORRELATION_ID
} from "./Services/service.utils";
import {ScreenType} from "./Constants";
import {ReservationType} from "Interfaces/GetReservations";
import AuthenticationProvider from "Authorization/auth-provider";
import AuthRequired from "Authorization/AuthRequired";
import useAuth from "Authorization/use-auth";

import {ReactAppMode} from "./Interfaces/ReactAppModes";
import {EXEC_MODE, execMode} from "./cfg";
import {ReactIntegrationMode} from "./Interfaces/ReactIntegrationMode";

let appHolder: App | null = null;
let cognitoToken: string | null = null;
let langSelect: string | null = null;
let apiUrl: string | null = null;
let apiResUrl: string | null = null;
let apiAutoAdjustUrl: string | null = null;
let apiResListUrl: string | null = null;
let apiCountryListUrl: string | null = null;
let checkEligibilityUrl: string | null = null;
let apiAds: string | null = null;
let apiPointsCalculatorUrl: string | null = null;
let apiBookUrl: string | null = null;
let apiUserContractsUrl: string | null = null;
let jahiaContentApiUrl: string | null = null;
let apiWaitlistUrl: string | null = null;
let jahiaRoomsApiUrl: string | null = null;
let aypUrl: string | null = null;
let waitlistsAypUrl: string | null = null;
let ownerPropertiesUrl: string | null = null;
let apiResWaitListUrl: string | null = null;
let reservationDetailUrl: string | null = null;
let reservationDetailUrlWeeks: string | null = null;
let apiOwnerProfileUrl: string | null = null;
let apiTimeout: string | null = null;
let logLevel: string | null = null;
let screenType: string | null = null;
let typedScreenType: ScreenType = ScreenType.APPLY_POINTS;
let aypResId: number | null = -1;
let resType: ReservationType = ReservationType.UPCOMING;
let apiTransListUrl: string | null = null;
let waitlistSummaryReviewUrl: string | null = null;
let waitListId: number | null = -1;
let apiWaitlistCreateUrl: string | null = null;
let resortLimit: string | null = null;
let pointsSearch: string | null = null;
let guestTerms: string | null = null;
let transferPointsContractUrl: string | null = null;

const reactHolder = document.getElementById("rtWebPanel");
execMode();
console.log("MODE = " + EXEC_MODE)


/**
 1.    We have two different deployment models for RT app
 a.    VCAP deployment (our initial integration approach, a lot of manual work deployment wise and hardly automatable),
 loading statically compiled JavaScript code into JSP pages
 b.    VOA deployment (RT react app is hosted as an independent piece of software in AWS S3),
 dedicated build/deploy pipeline, fully automated approach. The deployment pipeline could be found here:
 https://web-digital-jenkins.devops.ad.mvwcorp.com/view/(1.1)%20Continuous%20Integration%20Digital/job/mvw-engine-enhanced-reservation-ui/
 Since we are in a process of integrating it with NATO website we introduce another split
 1.    VOA (aka Salesforce integration) – integration is done by loading RT page passing all the required input on the URL (intMode=VOA or omitted)
 https://st01-reservation.vacationclub.com?ownerId=20070490&screenType=SEARCH_RESORTS
 https://st01-reservation.vacationclub.com?ownerId=20070490&screenType=TRANSACTION_HISTORY
 https://st01-reservation.vacationclub.com?ownerId=20002555&screenType=RESERVATIONS
 Minimal required info is Integration Mode, Customer ID and screen type we want to open.
 https://st01-reservation.vacationclub.com?ownerId=20070490&screenType=SEARCH_RESORTS#eyJhbGciOiJSUzI1N.......

 In this deployment/integration approach there are two options to get Associate PING token for further use on backend API calls
 a.    If there is no token specified on the URL call the react app knows how to communicate with Ping Auth and generate the token for us
 b.    If there is a token (#eyJhbGciOiJSUzI1N.......) we use it as is skipping Ping Auth process aal together.

 Notes: As far as backend API calls go, in VOA/SF case we have a special set of proxy APIs that are expecting Agents Ping token to be provided. The URL would look like this
 https://st01-gateway-marriottvacationclub-com.ad.mvwcorp.com/proxy/owner-search/voa/v1/owner/availability

 2.    AC (aka Nato)- similar integration but intMode=AC is a required param and token is a required part of the query url as well!!!
 https://st01-reservation.vacationclub.com?intMode=AC&ownerId=20070490&screenType=SEARCH_RESORTS#eyJhbGciOiJSUzI1N.......
 https://st01-reservation.vacationclub.com?intMode=AC&ownerId=20070490&screenType=TRANSACTION_HISTORY#eyJhbGciOiJSUzI1N.......
 https://st01-reservation.vacationclub.com?intMode=AC&ownerId=20002555&screenType=RESERVATIONS#eyJhbGciOiJSUzI1N.......
 Minimal required info is Integration Mode, Customer ID and screen type we want to open and COGNITO token.
 https://st01-reservation.vacationclub.com?intMode=AC&ownerId=20070490&screenType=SEARCH_RESORTS#eyJhbGciOiJSUzI1N.......

 Notes:  In this particular deployment/integration scenario the SSO token expected is a Cognito token NATO site would possess at the login time
 As far as backend API calls go, in VOA/AC case we have our regular set of proxy APIs that are expecting Cognito token to be provided. The URL would look like this
 https://st01-gateway-marriottvacationclub-com.ad.mvwcorp.com/proxy/owner-search/v1/owner/availability (it would not have /voa part on the path)

 */

if (reactHolder && [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {

    cognitoToken = reactHolder.getAttribute("data-cognito-sso-token");
    if (isUserChanged(cognitoToken)) {
        console.log(`logged user change detected; we are about to clean session storage!`);
        sessionStorage.clearAll();
    }
    /**
     * Doing this change to set token to invalid when cognitoToken is null
     */
    if(!cognitoToken || cognitoToken === ""){
        console.log('Token is Invalid !');
        sessionStorage.write(COGNITO_SSO_TOKEN, 'Invalid');
    }
    else {
        sessionStorage.write(COGNITO_SSO_TOKEN, cognitoToken);      
    }

    sessionStorage.write(OWNER_NUMBER, -1);

    const loc = window.location.toString().toLowerCase();
    if (loc.indexOf("jp.") > 0 || loc.indexOf("jp-") > 0 || loc.indexOf("local") > 0) {
        sessionStorage.write(LocalizationService.SELECTED_LANG, LocalizationService.JP);
    } else {
        sessionStorage.write(LocalizationService.SELECTED_LANG, LocalizationService.EN);
    }
    langSelect = sessionStorage.read(LocalizationService.SELECTED_LANG);

    screenType = reactHolder.getAttribute("data-screen-type");

    switch (screenType) {
        case "APPLY_POINTS":
            typedScreenType = ScreenType.APPLY_POINTS;
            aypResId = parseInt(reactHolder.getAttribute("data-ayp-res-id") as string);
            waitListId = parseInt(reactHolder.getAttribute("data-ayp-waitlist-id") as string);
            break;
        case "SUMMARY_REVIEW":
            typedScreenType = ScreenType.SUMMARY_REVIEW;
            aypResId = parseInt(reactHolder.getAttribute("data-ayp-res-id") as string);
            break;
        case "RESERVATIONS":
            typedScreenType = ScreenType.RESERVATIONS;
            aypResId = parseInt(reactHolder.getAttribute("data-ayp-res-id") as string);
            break;
        case "VIEW_RESERVATION":
            typedScreenType = ScreenType.VIEW_RESERVATION;
            aypResId = parseInt(reactHolder.getAttribute("data-ayp-res-id") as string);
            resType = reactHolder.getAttribute("data-res-type") as ReservationType;
            break;
        case "TRANSACTION_HISTORY":
            typedScreenType = ScreenType.TRANSACTION_HISTORY;
            aypResId = parseInt(reactHolder.getAttribute("data-ayp-res-id") as string);
            resType = reactHolder.getAttribute("data-res-type") as ReservationType;
            break;
        case "WAITLIST_SUMMARY_REVIEW":
            typedScreenType = ScreenType.WAITLIST_SUMMARY_REVIEW;
            aypResId = parseInt(reactHolder.getAttribute("data-ayp-res-id") as string);
            break;
        case "WAITLIST_MANAGEMENT":
            typedScreenType = ScreenType.WAITLIST_MANAGEMENT;
            aypResId = parseInt(reactHolder.getAttribute("data-ayp-res-id") as string);
            break;
        case "ARRIVING_GUEST_INFO":
            typedScreenType = ScreenType.ARRIVING_GUEST_INFO;
            break;
        default:
            typedScreenType = ScreenType.SEARCH_RESORTS;
    }

    apiUrl = reactHolder.getAttribute("data-api-url");
    apiResUrl = reactHolder.getAttribute("data-res-hold-url");
    apiAutoAdjustUrl = reactHolder.getAttribute("data-auto-adjust-url");
    apiResListUrl = reactHolder.getAttribute("data-res-list-url");
    apiCountryListUrl = reactHolder.getAttribute("data-country-list-url");
    apiAds = reactHolder.getAttribute("data-ads");
    apiPointsCalculatorUrl = reactHolder.getAttribute("data-points-calculator-url");
    apiBookUrl = reactHolder.getAttribute("data-res-book-url");
    apiUserContractsUrl = reactHolder.getAttribute("data-user-contracts-url");
    jahiaContentApiUrl = reactHolder.getAttribute("data-jahia-content-api-url");
    jahiaRoomsApiUrl = reactHolder.getAttribute("data-jahia-rooms-api-url");
    aypUrl = reactHolder.getAttribute("data-ayp-url");
    waitlistsAypUrl = reactHolder.getAttribute("data-waitlists-ayp-url");
    apiWaitlistUrl = reactHolder.getAttribute("data-waitlist-url");
    ownerPropertiesUrl = reactHolder.getAttribute("data-owner-properties-url");
    apiResWaitListUrl = reactHolder.getAttribute("data-res-wait-list-url");
    reservationDetailUrl = reactHolder.getAttribute("data-reservation-detail-url");
    apiOwnerProfileUrl = reactHolder.getAttribute("data-owner-profile-url");
    logLevel = reactHolder.getAttribute("data-log-level");
    pointsSearch = reactHolder.getAttribute("data-points-search");
    resortLimit = reactHolder.getAttribute("data-resort-limit");
    checkEligibilityUrl = reactHolder.getAttribute("data-check-eligibility-url");
    apiTimeout = reactHolder.getAttribute("data-api-timeout");
    apiTransListUrl = reactHolder.getAttribute("data-trans-list-url");
    checkEligibilityUrl = reactHolder.getAttribute("data-check-eligibility-url");
    apiWaitlistCreateUrl = reactHolder.getAttribute("data-waitlists-create-url");
    waitlistSummaryReviewUrl = reactHolder.getAttribute("data-waitlist-summary-review-url");
    guestTerms = reactHolder.getAttribute("data-guest-terms-url");
    transferPointsContractUrl = reactHolder.getAttribute("data-transfer-points-contracts-url");

    checkUserAuthenticated();

    ReactDOM.render(
        <App lang={langSelect ? langSelect : LocalizationService.EN}
             aypResId={aypResId || 0}
             waitListId={waitListId || 0}
             apiTimeout={apiTimeout ? apiTimeout : "20000"}
             apiUrl={apiUrl ? apiUrl : ""}
             apiResUrl={apiResUrl ? apiResUrl : ""}
             apiAutoAdjustUrl={apiAutoAdjustUrl ? apiAutoAdjustUrl : ""}
             apiResWaitListUrl={apiResWaitListUrl ? apiResWaitListUrl : ""}
             apiWaitlistUrl={apiWaitlistUrl ? apiWaitlistUrl : ""}
             apiResListUrl={apiResListUrl ? apiResListUrl : ""}
             apiCountryListUrl={apiCountryListUrl ? apiCountryListUrl : ""}
             apiPointsCalculatorUrl={apiPointsCalculatorUrl ? apiPointsCalculatorUrl : ""}
             apiBookUrl={apiBookUrl ? apiBookUrl : ""}
             apiUserContractsUrl={apiUserContractsUrl ? apiUserContractsUrl : ""}
             jahiaContentApiUrl={jahiaContentApiUrl ? jahiaContentApiUrl : ""}
             jahiaRoomsApiUrl={jahiaRoomsApiUrl ? jahiaRoomsApiUrl : ""}
             aypUrl={aypUrl ? aypUrl : ""}
             ownerPropertiesUrl={ownerPropertiesUrl ? ownerPropertiesUrl : ""}
             reservationDetailUrl={reservationDetailUrl ? reservationDetailUrl : ""}
             reservationDetailUrlWeeks={reservationDetailUrlWeeks ? reservationDetailUrlWeeks : ""}
             apiOwnerProfileUrl={apiOwnerProfileUrl ? apiOwnerProfileUrl : ""}
             apiTransListUrl={apiTransListUrl ? apiTransListUrl : ""}
             logLevel={logLevel ? logLevel : "warn"}
             pointsSearch={pointsSearch ? pointsSearch : ""}
             resortLimit={resortLimit ? resortLimit : ""}
             screenType={typedScreenType}
             checkEligibilityUrl={checkEligibilityUrl ? checkEligibilityUrl : ""}
             resType={resType}
             apiWaitlistCreateUrl={apiWaitlistCreateUrl ? apiWaitlistCreateUrl : ""}
             guestTermsUrl={guestTerms ? guestTerms : ""}
             transferPointsContractUrl={transferPointsContractUrl ? transferPointsContractUrl : ""}
             apiAds={apiAds !== null ? apiAds : ''}
             integrationMode={ReactAppMode.VCAP}
             ref={(elm) => {
                 appHolder = elm
             }}/>, reactHolder
    );
} else if ([ReactAppMode.VOA].includes(EXEC_MODE)) {

    console.log("VOA mode entered");

    let correlationId = getQueryParamFromLocation("x-correlation-id");
    if(correlationId !== null && correlationId !== "null" && correlationId !== undefined && correlationId !== "undefined" && correlationId.length !== 0) {
        console.log("aching correlation id");
        sessionStorage.write(X_CORRELATION_ID, correlationId);
        console.log("aching correlation id done");
    } else {
        correlationId = sessionStorage.read(X_CORRELATION_ID);
        if (correlationId !== null) {
            console.debug('correlationId loaded from the browser session = ' + correlationId);
        }
    }

    console.log("after caching correlation id");

    let intModeParam = getQueryParamFromLocation('intMode');
    if (intModeParam !== null && intModeParam !== "null" && intModeParam !== undefined && intModeParam !== "undefined" && intModeParam.length !== 0) {
        console.debug('Int-Mode is taken from request query params ' + intModeParam);
        sessionStorage.write(SYSTEM_INTEGRATION_MODE, intModeParam);
    } else {
        intModeParam = sessionStorage.read(SYSTEM_INTEGRATION_MODE);
        if (intModeParam !== null) {
            console.debug('Int-Mode loaded from the browser session = ' + intModeParam);
        }
    }

    let intMode = ReactIntegrationMode.VOA;
    switch (intModeParam) {
        case "AC":
            intMode = ReactIntegrationMode.AC;
            break;
        case "VSE":
            intMode = ReactIntegrationMode.VSE;
            break;
        default:
            intMode = ReactIntegrationMode.VOA;
    }

    let pingToken = getPingFedTokenFromLocation();
    if (pingToken !== null && pingToken !== "null" && pingToken !== "undefined" && pingToken.length !== 0) {
        console.debug('Token is taken from request query params');
        sessionStorage.write(COGNITO_SSO_TOKEN, pingToken);
    }

    let existingOwnerId = sessionStorage.read(OWNER_NUMBER);

    let ownerId = getQueryParamFromLocation('ownerId');
    if (ownerId !== null && ownerId !== "null" && ownerId !== undefined && ownerId !== "undefined" && ownerId.length !== 0) {
        console.log('Owner ID form the request query params = ' + ownerId);
        sessionStorage.write(OWNER_NUMBER, ownerId);
    } else {
        ownerId = sessionStorage.read(OWNER_NUMBER);
        console.log('Owner ID loaded from the browser session = ' + ownerId);
    }

    if (!ownerId) {
        console.error('Owner Id is not specified!');
        alert(`Owner Id is not specified!`);
    } else {
        screenType = getQueryParamFromLocation('screenType');
        if (screenType !== null) {
            console.debug('Screen Type form the request query params = ' + screenType);
            sessionStorage.write("SCREEN_TYPE", screenType);
        } else {
            screenType = sessionStorage.read("SCREEN_TYPE");
            console.debug('Screen Type loaded from the browser session = ' + screenType);
        }
        
        if (existingOwnerId !== null && existingOwnerId !== "null" && existingOwnerId !== "undefined" && existingOwnerId.length !== 0 && ownerId !== "null" && ownerId !== "undefined" && ownerId.length !== 0 && ownerId !== existingOwnerId) {
            console.log(`logged user change detected; we are about to clean session storage!`);
            sessionStorage.clearAll();
            sessionStorage.write(OWNER_NUMBER, ownerId);
            sessionStorage.write("SCREEN_TYPE", screenType);
            if (pingToken !== null && pingToken !== "null" && pingToken !== "undefined" && pingToken.length !== 0) {
                sessionStorage.write(COGNITO_SSO_TOKEN, pingToken);
            }
        }

        switch (screenType) {
            case "RESERVATIONS":
                typedScreenType = ScreenType.RESERVATIONS;
                break;
            case "TRANSACTION_HISTORY":
                typedScreenType = ScreenType.TRANSACTION_HISTORY;
                break;
            case "SUMMARY_REVIEW":
                typedScreenType = ScreenType.SUMMARY_REVIEW;
                break;
            case "CANCEL_RESERVATION":
                typedScreenType = ScreenType.CANCEL_RESERVATION;
                break;
            case "WAITLIST_MANAGEMENT":
                typedScreenType = ScreenType.WAITLIST_MANAGEMENT;
                break;
            case "WAITLIST_SUMMARY_REVIEW":
                typedScreenType = ScreenType.WAITLIST_SUMMARY_REVIEW;
                break;
            case "ARRIVING_GUEST_INFO":
                typedScreenType = ScreenType.ARRIVING_GUEST_INFO; //TODO: Remove this, only for testing purposes
                break;
            case "TRANSFER_POINTS":
                typedScreenType = ScreenType.TRANSFER_POINTS
                break;
            default:
                typedScreenType = ScreenType.SEARCH_RESORTS;
        }

        let clientId = process.env.REACT_APP_PING_IDENTITY_CLIENT_ID;
        let clientSecret = process.env.REACT_APP_PING_IDENTITY_CLIENT_SECRET;
        let provider = process.env.REACT_APP_PING_IDENTITY_PROVIDER;
        let authEndpoint = process.env.REACT_APP_PING_IDENTITY_AUTH_ENDPOINT;
        let tokenEndpoint = process.env.REACT_APP_PING_IDENTITY_TOKEN_ENDPOINT;
        let redirectUri = process.env.REACT_APP_PING_IDENTITY_REDIRECT_URI;
        let apiCallTimeout = process.env.REACT_APP_API_CALL_TIMEOUT;

        const RtAuthorizedAccess = () => {
            const auth: any = useAuth();
            const {access_token} = auth.token;

            sessionStorage.write(COGNITO_SSO_TOKEN, access_token);
            return (
                <App lang={langSelect ? langSelect : LocalizationService.EN}
                     aypResId={aypResId || 0}
                     waitListId={waitListId || 0}
                     apiTimeout={apiCallTimeout ? apiCallTimeout : "20000"}
                     apiUrl={apiUrl ? apiUrl : ""}
                     apiResUrl={apiResUrl ? apiResUrl : ""}
                     apiAutoAdjustUrl={apiAutoAdjustUrl ? apiAutoAdjustUrl : ""}
                     apiResWaitListUrl={apiResWaitListUrl ? apiResWaitListUrl : ""}
                     apiWaitlistUrl={apiWaitlistUrl ? apiWaitlistUrl : ""}
                     apiResListUrl={apiResListUrl ? apiResListUrl : ""}
                     apiCountryListUrl={apiCountryListUrl ? apiCountryListUrl : ""}
                     apiPointsCalculatorUrl={apiPointsCalculatorUrl ? apiPointsCalculatorUrl : ""}
                     apiBookUrl={apiBookUrl ? apiBookUrl : ""}
                     apiUserContractsUrl={apiUserContractsUrl ? apiUserContractsUrl : ""}
                     jahiaContentApiUrl={jahiaContentApiUrl ? jahiaContentApiUrl : ""}
                     jahiaRoomsApiUrl={jahiaRoomsApiUrl ? jahiaRoomsApiUrl : ""}
                     aypUrl={aypUrl ? aypUrl : ""}
                     ownerPropertiesUrl={ownerPropertiesUrl ? ownerPropertiesUrl : ""}
                     reservationDetailUrl={reservationDetailUrl ? reservationDetailUrl : ""}
                     reservationDetailUrlWeeks={reservationDetailUrlWeeks ? reservationDetailUrlWeeks : ""}
                     apiOwnerProfileUrl={apiOwnerProfileUrl ? apiOwnerProfileUrl : ""}
                     apiTransListUrl={apiTransListUrl ? apiTransListUrl : ""}
                     pointsSearch={pointsSearch? pointsSearch : ""}
                     resortLimit={resortLimit ? resortLimit : ""}
                     logLevel={logLevel ? logLevel : "warn"}
                     screenType={typedScreenType}
                     checkEligibilityUrl={checkEligibilityUrl ? checkEligibilityUrl : ""}
                     resType={resType}
                     apiWaitlistCreateUrl={apiWaitlistCreateUrl ? apiWaitlistCreateUrl : ""}
                     guestTermsUrl={guestTerms ? guestTerms : ""}
                     apiAds={apiAds !== null ? apiAds : ''}
                     integrationMode={intMode !== null ? intMode : ''}
                     transferPointsContractUrl={transferPointsContractUrl ? transferPointsContractUrl : ""}
                     ref={(elm) => {
                         appHolder = elm
                     }}/>)
        }

        pingToken = sessionStorage.read(COGNITO_SSO_TOKEN);
        sessionStorage.write(LocalizationService.SELECTED_LANG, LocalizationService.EN);

        if (pingToken !== null && pingToken !== "null" && pingToken !== "undefined" && pingToken.length !== 0) {
            console.log("if -  Token available..", pingToken)
            ReactDOM.render(
                <App lang={langSelect ? langSelect : LocalizationService.EN}
                     aypResId={aypResId || 0}
                     waitListId={waitListId || 0}
                     apiTimeout={apiCallTimeout ? apiCallTimeout : "20000"}
                     apiUrl={apiUrl ? apiUrl : ""}
                     apiResUrl={apiResUrl ? apiResUrl : ""}
                     apiAutoAdjustUrl={apiAutoAdjustUrl ? apiAutoAdjustUrl : ""}
                     apiResWaitListUrl={apiResWaitListUrl ? apiResWaitListUrl : ""}
                     apiWaitlistUrl={apiWaitlistUrl ? apiWaitlistUrl : ""}
                     apiResListUrl={apiResListUrl ? apiResListUrl : ""}
                     apiCountryListUrl={apiCountryListUrl ? apiCountryListUrl : ""}
                     apiPointsCalculatorUrl={apiPointsCalculatorUrl ? apiPointsCalculatorUrl : ""}
                     apiBookUrl={apiBookUrl ? apiBookUrl : ""}
                     apiUserContractsUrl={apiUserContractsUrl ? apiUserContractsUrl : ""}
                     jahiaContentApiUrl={jahiaContentApiUrl ? jahiaContentApiUrl : ""}
                     jahiaRoomsApiUrl={jahiaRoomsApiUrl ? jahiaRoomsApiUrl : ""}
                     aypUrl={aypUrl ? aypUrl : ""}
                     ownerPropertiesUrl={ownerPropertiesUrl ? ownerPropertiesUrl : ""}
                     reservationDetailUrl={reservationDetailUrl ? reservationDetailUrl : ""}
                     reservationDetailUrlWeeks= {reservationDetailUrlWeeks ? reservationDetailUrlWeeks : ""}
                     apiOwnerProfileUrl={apiOwnerProfileUrl ? apiOwnerProfileUrl : ""}
                     apiTransListUrl={apiTransListUrl ? apiTransListUrl : ""}
                     pointsSearch={pointsSearch? pointsSearch : ""}
                     resortLimit={resortLimit ? resortLimit : ""}
                     logLevel={logLevel ? logLevel : "warn"}
                     screenType={typedScreenType}
                     checkEligibilityUrl={checkEligibilityUrl ? checkEligibilityUrl : ""}
                     resType={resType}
                     apiWaitlistCreateUrl={apiWaitlistCreateUrl ? apiWaitlistCreateUrl : ""}
                     guestTermsUrl={guestTerms ? guestTerms : ""}
                     transferPointsContractUrl={transferPointsContractUrl ? transferPointsContractUrl : ""}
                     apiAds={apiAds ? apiAds : ''}
                     integrationMode={intMode !== null ? intMode : ''}
                     ref={(elm) => {
                         appHolder = elm
                     }}/>, reactHolder
            );
        } else {
            console.log("else - Token not available so Triggered for reauthentication :  ", pingToken)
            let app = (
                <AuthenticationProvider
                    clientId={clientId}
                    clientSecret={clientSecret}
                    provider={provider}
                    authorizationEndpoint={authEndpoint}
                    tokenEndpoint={tokenEndpoint}
                    redirectUri={redirectUri}
                >
                    <AuthRequired>
                        <RtAuthorizedAccess/>
                    </AuthRequired>
                </AuthenticationProvider>
            )

            ReactDOM.render(app, reactHolder);
        }
    }
}

//check user access token every 10 min to see if it is already expired
//if token expired, force re-login
function checkUserAuthenticated() {
    if (!isUserAuthenticated()) {
        handle401Error({message: 'Access Token Expired!', code: 401});
    } else {
        setTimeout(checkUserAuthenticated, 600000);
    }
}

function getQueryParamFromLocation(paramToFind: string) {
    const split = window.location.toString().split('?');
    if (split.length < 2) {
        return null;
    }

    let queryParams = split[1];
    let tokenStart = queryParams.indexOf('#');
    if (tokenStart > 0) {
        queryParams = queryParams.substring(0, tokenStart);
    }

    const pairs = queryParams.split('&');
    for (const pair of pairs) {
        const [key, value] = pair.split('=');
        if (key === paramToFind) {
            return decodeURIComponent(value || '');
        }
    }
    return null;
}

function getPingFedTokenFromLocation() {
    const split = window.location.toString().split('#');
    if (split.length < 2) {
        return null;
    }
    return split[1];
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
